import utils from '@/utils/utils'

export const domBgColorSet = (bgInfo, elemId, coverY = 'auto') => {
  let { backgroundType, background, transparency } = bgInfo
  if (utils.isKTDP()) transparency = 100
  // console.log(`${elemId} domBgColorSet=>`, background, backgroundType, transparency)
  let elem = document.getElementById(elemId)
  if (!elem || !background) return
  let styleString = ''
  switch (backgroundType) {
    case 2: // 背景色
      { let arr = background && background.split(','); let rgba = ''
        if (arr.length > 1) {
          rgba = `${utils.hexToRgba(arr[0], transparency / 100)} url(${arr[1]}) center top / 100% no-repeat`;
        } else {
          rgba = utils.hexToRgba(arr[0], transparency / 100)
        }
        styleString = `background: ${rgba}; -webkit-backdrop-filter: blur(5px); backdrop-filter: blur(5px);` }
      break;
    case 3: // 背景图
    // { let style = `url(${background}) center top / 100% no-repeat`;
      styleString = `background: url(${background}) center top no-repeat; background-size: 100% ${coverY}; -webkit-backdrop-filter: blur(5px); backdrop-filter: blur(5px);`
      break;
    case 4: // 左右渐变
      { let colors = background.split(',')
        let style = `${utils.hexToRgba(colors[1], transparency / 100)} linear-gradient(to right, ${utils.hexToRgba(colors[0], transparency / 100)}, ${utils.hexToRgba(colors[1], transparency / 100)})`
        styleString = `background: ${style}; -webkit-backdrop-filter: blur(5px); backdrop-filter: blur(5px);` }
      break;
    case 5: // 上下渐变
      { let colors = background.split(',')
        let style = `${utils.hexToRgba(colors[1], transparency / 100)} linear-gradient(to bottom, ${utils.hexToRgba(colors[0], transparency / 100)}, ${utils.hexToRgba(colors[1], transparency / 100)})`
        styleString = `background: ${style}; background-size: 100% ${coverY}; -webkit-backdrop-filter: blur(5px); backdrop-filter: blur(5px);` }
      break;
    case 6: // 透明
    // elem.style = `background: transparent;`
      styleString = `background: transparent; -webkit-backdrop-filter: blur(5px); backdrop-filter: blur(5px);`
      break;
  }
  elem.setAttribute('style', styleString)
  elem.style.cssText = styleString
}

export const categoryNav = [
  {
    productCateId: 2729,
    name: '空调',
    tag: '悦享呼吸',
  }, {
    productCateId: 2725,
    name: '洗衣机',
    tag: '守护洁净',
  }, 
  {
    productCateId: 9627,
    name: '冰冷电器',
    tag: '原味鲜活',
  }, 
  // {
  //   productCateId: 2723,
  //   name: '冰箱',
  //   tag: '原味鲜活',
  // }, 
  {
    productCateId: 2743,
    name: '彩电',
    tag: '视听万象',
  }, {
    productCateId: 2741,
    name: '热水器',
    tag: '温暖到家',
  }, {
    productCateId: 2742,
    name: '厨房电器',
    tag: '乐享美味',
  }, 
  // {
  //   productCateId: 2726,
  //   name: '冷柜',
  //   tag: '冻力强劲',
  // }, 
  {
    productCateId: 2973,
    name: '智能产品',
    tag: '科技体验',
  }, {
    productCateId: 4255,
    name: '生活电器',
    tag: '品质生活',
  }, {
    productCateId: 2774,
    name: '水家电',
    tag: '洁净用水',
  }, 
  // {
  //   productCateId: 2811,
  //   name: '家用中央空调',
  //   tag: '舒适陪伴',
  // }
]
